import { Grid } from "@mui/material";
import Cards from "./cards";
import i18n from "src/locales/i18n";
import useAuth from "src/hooks/useAuth";

const Summary = ({ summary }) => {
  const { user } = useAuth();
  const summaryCard = [
    {
      isInvestor: true,
      title: "Income",
      icon: "solar:money-bag-bold",
      color: "#6699ff",
      key: "income",
    },

    {
      isInvestor: true,
      title: "Expense",
      icon: "grommet-icons:money",
      color: "#d279a6",
      key: "expense",
    },
    {
      isInvestor: true,
      title: "User Balance",
      icon: "solar:wallet-money-bold-duotone",
      color: "#d279a6",
      key: "balance",
    },
  ];

  return (
    <>
      {summaryCard
        // .filter((card) => {
        // if (user.user_type === "customer") {
        //   return card.isInvestor;
        // }
        // return !card.isInvestor;
        // })
        .map((props) => (
          <Grid item xs={12} sm={5} md={4} key={props.key}>
            <Cards {...props} total={summary[props.key]} />
          </Grid>
        ))}
    </>
  );
};

export default Summary;
